<template>
  <div class="home">
    <div class="background"></div>
    <div class="header">
      <Menu />
    </div>
    <!-- <div class="text-title">
      <div class="text-background">
        <h1>
          <img src="../assets/versada.png" width="250px" alt="Versada" />
        </h1>
        <h2>Tu inmobiliaria de confianza</h2>
      </div>
    </div>-->
    <div class="container container-home">
      <Search :horizontal="true" />
      <Carousel title="Propiedades destacadas" :properties="properties" />
      <About />
      <Carousel title="Novedades" :properties="news" />
    </div>
    <Footer class="footer-home"/>
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import Search from "@/components/Search";
import Carousel from "@/components/Carousel";
import About from "@/components/About";
import Footer from "@/components/Footer";
import PropertyRepository from "@/repositories/PropertyRepository";

export default {
  name: "Home",
  components: {
    Menu,
    Search,
    Carousel,
    About,
    Footer,
  },
  data() {
    return {
      properties: [],
      news: [],
    };
  },
  metaInfo() {
    return {
      title:
        "Tus agentes inmobiliarios de Talavera " +
        process.env.VUE_APP_META_TITLE,
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Martins agentes inmobiliarios, tus agentes inmobiliarios en Talavera de confianza, contacta con nosotros para encontrar el piso de tus sueños. Disponemos de pisos, casas, locales, oficinas, garajes y fincas en venta y alquiler",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: process.env.VUE_APP_LINK + this.$route.path,
        },
      ],
    };
  },
  created() {
    this.getHomeProperties();
    this.getNewProperties();
  },
  methods: {
    async getHomeProperties() {
      let params = { limit: 9, propertyType: 1, highlighted: 1 };
      const { data } = await PropertyRepository.search(params);
      this.properties = data;
    },
    async getNewProperties() {
      let params = { limit: 9, propertyType: 1 };
      const { data } = await PropertyRepository.search(params);
      this.news = data;
    },
  },
};
</script>

<style>
.background {
  background-image: url("../assets/principal.jpg");
  background-repeat: repeat-x;
  position: relative;
  top: -90px;
  width: 100%;
  height: 900px;
  z-index: -1;
}

.container-home {
  top: -350px;
  position: relative;
}

.container-home .search.horizontal {
  top: -190px;
  position: relative;
}

.text-title {
  color: #6e9360;
  text-align: center;
  margin-top: -540px;
  margin-bottom: 150px;
}
.text-background {
  background-color: #ffffffa8;
  padding: 15px;
}
.footer-home {
  margin-top: -300px;
}
</style>